function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';

// Icon component wrapper
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Icon = _ref => {
  let {
    children,
    size = 16,
    className = ''
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: className,
    children: children
  });
};

// Individual icon components
export const TextIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M4 7V4h16v3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9 20h6"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12 4v16"
  })]
}));
export const LongTextIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "14,2 14,8 20,8"
  }), /*#__PURE__*/_jsx("line", {
    x1: "16",
    y1: "13",
    x2: "8",
    y2: "13"
  }), /*#__PURE__*/_jsx("line", {
    x1: "16",
    y1: "17",
    x2: "8",
    y2: "17"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "10,9 9,9 8,9"
  })]
}));
export const EmailIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "22,6 12,13 2,6"
  })]
}));
export const NumberIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M3 5v14"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8 5v14"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12 5v14"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17 5v14"
  }), /*#__PURE__*/_jsx("path", {
    d: "M21 5v14"
  })]
}));
export const PasswordIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "11",
    width: "18",
    height: "11",
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "12",
    cy: "16",
    r: "1"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  })]
}));
export const UrlIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
  }), /*#__PURE__*/_jsx("path", {
    d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
  })]
}));
export const PhoneIcon = props => /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  })
}));
export const SearchIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), /*#__PURE__*/_jsx("path", {
    d: "m21 21-4.35-4.35"
  })]
}));
export const TextAreaIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/_jsx("line", {
    x1: "7",
    y1: "8",
    x2: "17",
    y2: "8"
  }), /*#__PURE__*/_jsx("line", {
    x1: "7",
    y1: "12",
    x2: "17",
    y2: "12"
  }), /*#__PURE__*/_jsx("line", {
    x1: "7",
    y1: "16",
    x2: "13",
    y2: "16"
  })]
}));
export const SelectIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("polyline", {
    points: "6 9 12 15 18 9"
  }), /*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "3",
    rx: "1"
  })]
}));
export const MultiSelectIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("line", {
    x1: "3",
    y1: "6",
    x2: "21",
    y2: "6"
  }), /*#__PURE__*/_jsx("line", {
    x1: "3",
    y1: "12",
    x2: "21",
    y2: "12"
  }), /*#__PURE__*/_jsx("line", {
    x1: "3",
    y1: "18",
    x2: "21",
    y2: "18"
  })]
}));
export const RadioIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })]
}));
export const CheckboxIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("polyline", {
    points: "9,11 12,14 22,4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
  })]
}));
export const SwitchIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "1",
    y: "9",
    width: "22",
    height: "6",
    rx: "3",
    ry: "3"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "8",
    cy: "12",
    r: "3"
  })]
}));
export const DateIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/_jsx("line", {
    x1: "16",
    y1: "2",
    x2: "16",
    y2: "6"
  }), /*#__PURE__*/_jsx("line", {
    x1: "8",
    y1: "2",
    x2: "8",
    y2: "6"
  }), /*#__PURE__*/_jsx("line", {
    x1: "3",
    y1: "10",
    x2: "21",
    y2: "10"
  })]
}));
export const TimeIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "12,6 12,12 16,14"
  })]
}));
export const DateTimeIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/_jsx("line", {
    x1: "16",
    y1: "2",
    x2: "16",
    y2: "6"
  }), /*#__PURE__*/_jsx("line", {
    x1: "8",
    y1: "2",
    x2: "8",
    y2: "6"
  }), /*#__PURE__*/_jsx("line", {
    x1: "3",
    y1: "10",
    x2: "21",
    y2: "10"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "17",
    cy: "17",
    r: "3"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "17,15 17,17 18,18"
  })]
}));
export const FileIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "14,2 14,8 20,8"
  }), /*#__PURE__*/_jsx("line", {
    x1: "16",
    y1: "13",
    x2: "8",
    y2: "13"
  }), /*#__PURE__*/_jsx("line", {
    x1: "16",
    y1: "17",
    x2: "8",
    y2: "17"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "10,9 9,9 8,9"
  })]
}));
export const AttachmentIcon = props => /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
  })
}));
export const ImageIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "8.5",
    cy: "8.5",
    r: "1.5"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "21,15 16,10 5,21"
  })]
}));
export const RangeIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("line", {
    x1: "3",
    y1: "12",
    x2: "21",
    y2: "12"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "8",
    cy: "12",
    r: "3"
  })]
}));
export const ColorIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "13.5",
    cy: "6.5",
    r: ".5"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "17.5",
    cy: "10.5",
    r: ".5"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "8.5",
    cy: "7.5",
    r: ".5"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "6.5",
    cy: "12.5",
    r: ".5"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"
  })]
}));
export const RatingIcon = props => /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: /*#__PURE__*/_jsx("polygon", {
    points: "12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
  })
}));
export const RepeaterIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("polyline", {
    points: "17 1 21 5 17 9"
  }), /*#__PURE__*/_jsx("path", {
    d: "M3 11V9a4 4 0 0 1 4-4h14"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "7 23 3 19 7 15"
  }), /*#__PURE__*/_jsx("path", {
    d: "M21 13v2a4 4 0 0 1-4 4H3"
  })]
}));
export const SignatureIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M3 17c3.333-3.333 5-6 9-6s6 2.667 9 6"
  }), /*#__PURE__*/_jsx("path", {
    d: "M3 17h18"
  })]
}));
export const DividerIcon = props => /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: /*#__PURE__*/_jsx("line", {
    x1: "3",
    y1: "12",
    x2: "21",
    y2: "12"
  })
}));
export const HeadingIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M6 12h12"
  }), /*#__PURE__*/_jsx("path", {
    d: "M6 20V4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18 20V4"
  })]
}));
export const ParagraphIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M13 4v16"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17 4v16"
  }), /*#__PURE__*/_jsx("path", {
    d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13"
  })]
}));
export const HiddenIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12 1v6"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12 17v6"
  })]
}));
export const CurrencyIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12 6v12"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15 9h-3a3 3 0 0 0 0 6h3"
  })]
}));
export const PriceIcon = props => /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
  })
}));
export const TagsIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
  }), /*#__PURE__*/_jsx("line", {
    x1: "7",
    y1: "7",
    x2: "7.01",
    y2: "7"
  })]
}));
export const SectionIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/_jsx("line", {
    x1: "3",
    y1: "9",
    x2: "21",
    y2: "9"
  }), /*#__PURE__*/_jsx("line", {
    x1: "9",
    y1: "3",
    x2: "9",
    y2: "21"
  })]
}));
export const CollapsibleIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
  }), /*#__PURE__*/_jsx("path", {
    d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
  })]
}));
export const TabsIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M3 3h18v18H3z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M3 9h18"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9 3v18"
  })]
}));
export const ColumnsIcon = props => /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, props), {}, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/_jsx("line", {
    x1: "12",
    y1: "3",
    x2: "12",
    y2: "21"
  })]
}));

// Icon mapping for field types
export const FIELD_ICONS = {
  text: TextIcon,
  email: EmailIcon,
  number: NumberIcon,
  password: PasswordIcon,
  url: UrlIcon,
  tel: PhoneIcon,
  search: SearchIcon,
  textarea: TextAreaIcon,
  select: SelectIcon,
  'multi-select': MultiSelectIcon,
  radio: RadioIcon,
  checkbox: CheckboxIcon,
  switch: SwitchIcon,
  date: DateIcon,
  time: TimeIcon,
  'datetime-local': DateTimeIcon,
  month: DateIcon,
  week: DateIcon,
  file: FileIcon,
  attachment: AttachmentIcon,
  image: ImageIcon,
  range: RangeIcon,
  color: ColorIcon,
  rating: RatingIcon,
  repeater: RepeaterIcon,
  signature: SignatureIcon,
  divider: DividerIcon,
  heading: HeadingIcon,
  paragraph: ParagraphIcon,
  hidden: HiddenIcon,
  currency: CurrencyIcon,
  price: PriceIcon,
  tags: TagsIcon,
  section: SectionIcon,
  collapsible: CollapsibleIcon,
  tabs: TabsIcon,
  columns: ColumnsIcon
};
export default FIELD_ICONS;